import React, { useState, useEffect, useRef } from "react";
import { Router } from "@abyss/web/ui/Router";
import { Button } from "@abyss/web/ui/Button";

import styles from "./homecardhover.module.css";

import classNames from "classnames";

export const HomeCardHover = () => {
  return (
    <React.Fragment>
      <Router.MetaTags title="Home Card Hover Prototype" />

      <section className={styles.background}>
        <div className={styles.innerBox}>
          <div className={styles.card}>
            <div className={styles.cardContent}>
              <div className={styles.headline}>Create a profile</div>
              <div className={styles.cardButton}>
                <Button variant="outline">Save your information</Button>
              </div>
            </div>
          </div>

          <div className={styles.card}>
            <div className={styles.cardContent}>
              <div className={styles.headline}>Meet with us</div>
              <div className={styles.cardButton}>
                <Button variant="outline">Find an agent</Button>
              </div>
            </div>
          </div>

          <div className={styles.card}>
            <div className={styles.cardContent}>
              <div className={styles.headline}>Check your eligibility</div>
              <div className={styles.cardButton}>
                <Button variant="outline">See if you qualify</Button>
              </div>
            </div>
          </div>

          <div className={styles.card}>
            <div className={styles.cardContent}>
              <div className={styles.headline}>Learn about Medicare</div>
              <div className={styles.cardButton}>
                <Button variant="outline">Get the details</Button>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className={styles.background}>
        <div className={styles.innerBox}>
          <div className={classNames(styles.card, styles.cardTwo)}>
            <div className={styles.cardContent}>
              <div className={styles.headline}>Create a profile</div>
              <div className={styles.cardButton}>
                <Button variant="outline">Save your information</Button>
              </div>
            </div>
          </div>

          <div className={classNames(styles.card, styles.cardTwo)}>
            <div className={styles.cardContent}>
              <div className={styles.headline}>Meet with us</div>
              <div className={styles.cardButton}>
                <Button variant="outline">Find an agent</Button>
              </div>
            </div>
          </div>

          <div className={classNames(styles.card, styles.cardTwo)}>
            <div className={styles.cardContent}>
              <div className={styles.headline}>Check your eligibility</div>
              <div className={styles.cardButton}>
                <Button variant="outline">See if you qualify</Button>
              </div>
            </div>
          </div>

          <div className={classNames(styles.card, styles.cardTwo)}>
            <div className={styles.cardContent}>
              <div className={styles.headline}>Learn about Medicare</div>
              <div className={styles.cardButton}>
                <Button variant="outline">Get the details</Button>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className={styles.background}>
        <div className={styles.innerBox}>
          <div className={classNames(styles.card, styles.cardThree)}>
            <div className={styles.cardContent}>
              <div className={styles.headline}>Create a profile</div>
              <div className={styles.cardButton}>
                <Button variant="outline">Save your information</Button>
              </div>
            </div>
          </div>

          <div className={classNames(styles.card, styles.cardThree)}>
            <div className={styles.cardContent}>
              <div className={styles.headline}>Meet with us</div>
              <div className={styles.cardButton}>
                <Button variant="outline">Find an agent</Button>
              </div>
            </div>
          </div>

          <div className={classNames(styles.card, styles.cardThree)}>
            <div className={styles.cardContent}>
              <div className={styles.headline}>Check your eligibility</div>
              <div className={styles.cardButton}>
                <Button variant="outline">See if you qualify</Button>
              </div>
            </div>
          </div>

          <div className={classNames(styles.card, styles.cardThree)}>
            <div className={styles.cardContent}>
              <div className={styles.headline}>Learn about Medicare</div>
              <div className={styles.cardButton}>
                <Button variant="outline">Get the details</Button>
              </div>
            </div>
          </div>
        </div>
      </section>
    </React.Fragment>
  );
};
